import React, { Suspense, useCallback, useEffect } from "react";
import { Outlet } from "react-router-dom";
import LoadingScreen from "@components/LoadingScreen/LoadingScreen";
import { useMobileSidebar } from "@contexts/MobileSidebarContext";
import { useIsDrawerViewport } from "@/hooks/useIsPhoneViewport";
import AppSidebar from "../app-sidebar/AppSidebar";
import "./BoardFullWidthLayout.scss";

const BoardFullWidthLayout: React.FC = () => {
  // These routes are full width by design: on a desktop the header carries the
  // navigation and there is no rail. At drawer widths the header's navigation
  // is gone too, which left Connections, Numbers, Archived Tasks and Settings
  // with no way out at all — not even back to the board.
  const isDrawer = useIsDrawerViewport();
  const {
    isOpen: isMobileSidebarOpen,
    close: handleMobileClose,
    registerSidebar,
  } = useMobileSidebar();

  // Lets the header's menu button know there is a drawer to open.
  useEffect(() => {
    if (!isDrawer) return;
    return registerSidebar();
  }, [isDrawer, registerSidebar]);

  // The drawer is never the collapsed rail, so there is nothing to collapse.
  const handleCollapse = useCallback(() => undefined, []);

  return (
    <div className="board-full-width">
      {isDrawer && (
        <AppSidebar
          isCollapsed={false}
          isMobileOpen={isMobileSidebarOpen}
          onCollapse={handleCollapse}
          onMobileClose={handleMobileClose}
        />
      )}
      <Suspense fallback={<LoadingScreen inline />}>
        <Outlet />
      </Suspense>
    </div>
  );
};

export default BoardFullWidthLayout;
